export type TipType = {
  translationKey: string
  crossed?: boolean
  number: number
}

export const tips: TipType[] = [
  {
    translationKey: "dontLikeTheLabradorsNameYouCan",
    number: 1
  },
  {
    translationKey: "inAdditionToTheMainEarnings",
    number: 2
  },
  {
    translationKey: "yourLabradorCannotMineIndefinitelyAsIt",
    number: 3
  },
  {
    translationKey: "yourGoldIncomeDepends",
    number: 4
  },
  {
    translationKey: "byDiggingToTheNewLocation",
    number: 5
  },
  {
    translationKey: "youCanUpgradeYourLabradorsShovel",
    number: 6
  },
  {
    translationKey: "whoStoleThisTip",
    number: 7
  },
  {
    translationKey: "woofWoof",
    number: 8
  }
]

export function getRandomFromArray<T>(array: T[]) {
  return array[Math.floor(Math.random() * array.length)]
}
